import React, { useMemo } from 'react';
import SubPage, { PageActions } from '#/common/components/SubPage';
import Findings from '../components/Findings';
import { useSearchParams } from 'react-router-dom';
import { PageAction } from '#/app/providers/PageProvider';

const FindingsPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const assetId = searchParams.get('assetId') || undefined;

  const actions = useMemo<PageAction[]>(
    () => [
      {
        id: 'new-finding',
        alwaysShow: true,
        type: 'button',
        props: {
          type: 'submit',
          icon: 'add',
          label: 'Create New Finding',
          responsive: true,
          path: `/findings/new${assetId ? `?assetId=${assetId}` : ''}`,
        },
      },
    ],
    [assetId],
  );

  return (
    <SubPage title="Findings" type="list">
      <PageActions actions={actions} />
      <Findings hideNewAction />
    </SubPage>
  );
};

export default FindingsPage;
